import type { Permission } from "@/features/roles/constants/permissions";

import { EmptyState } from "@heroui-pro/react/empty-state";
import { Icon } from "@iconify/react";

import { getPermissionLabel } from "@/features/roles/helpers/permissions";

interface NoAccessProps {
  /** What the viewer's role lacks; its wording is what they ask an admin for. */
  permission: Permission;
  className?: string;
}

/**
 * Where someone asked to open a thing their role can't read: a page, a shared
 * link, a record panel. Lists and buttons inside a page hide instead.
 */
export const NoAccess = ({ permission, className }: NoAccessProps) => (
  <EmptyState className={className}>
    <EmptyState.Header>
      <EmptyState.Media className="text-muted">
        <Icon fontSize={28} icon="solar:lock-keyhole-minimalistic-linear" />
      </EmptyState.Media>
      <EmptyState.Title>You don&apos;t have access to this</EmptyState.Title>
      <EmptyState.Description className="max-w-sm text-pretty">
        Ask a workspace admin to add “{getPermissionLabel(permission)}” to your
        role.
      </EmptyState.Description>
    </EmptyState.Header>
  </EmptyState>
);
